/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UserService } from './services/user.service';
import { AdminService } from './services/admin.service';
import { StorageService } from './services/storage.service';
import { SettingService } from './services/setting.service';
import { InquiryService } from './services/inquiry.service';
import { FaqService } from './services/faq.service';
import { HealthService } from './services/health.service';
import { UserLogService } from './services/user-log.service';
import { AdminDocumentService } from './services/admin-document.service';
import { VendorDocumentService } from './services/vendor-document.service';
import { VendorWorkspaceService } from './services/vendor-workspace.service';
import { VendorWorkspaceUserService } from './services/vendor-workspace-user.service';
import { VendorJoinLogService } from './services/vendor-join-log.service';
import { VendorWorkspaceInviteLogsService } from './services/vendor-workspace-invite-logs.service';
import { VendorWorkspaceApproveLogService } from './services/vendor-workspace-approve-log.service';
import { VendorActionLogService } from './services/vendor-action-log.service';
import { ClientWorkspaceService } from './services/client-workspace.service';
import { ClientWorkspaceUserService } from './services/client-workspace-user.service';
import { ClientWorkspaceJoinLogService } from './services/client-workspace-join-log.service';
import { ClientWorkspaceInviteLogService } from './services/client-workspace-invite-log.service';
import { ClientActionLogService } from './services/client-action-log.service';
import { PartnerJoinRequestService } from './services/partner-join-request.service';
import { PlaylistService } from './services/playlist.service';
import { DeviceService } from './services/device.service';
import { DeviceGroupService } from './services/device-group.service';
import { VendorInquiryService } from './services/vendor-inquiry.service';
import { AsService } from './services/as.service';
import { AdminNoticeService } from './services/admin-notice.service';
import { VendorNoticeService } from './services/vendor-notice.service';
import { NotificationService } from './services/notification.service';
import { CreditHistoryLogService } from './services/credit-history-log.service';
import { CreditRequestLogService } from './services/credit-request-log.service';
import { ContentsRequestService } from './services/contents-request.service';
import { ContentsRequestCommentService } from './services/contents-request-comment.service';
import { ContentsRequestResultService } from './services/contents-request-result.service';
import { ContentsRequestPaymentService } from './services/contents-request-payment.service';
import { ContentsRequestEstimateService } from './services/contents-request-estimate.service';
import { VendorTicketService } from './services/vendor-ticket.service';
import { VendorTicketLogService } from './services/vendor-ticket-log.service';
import { ClientTicketService } from './services/client-ticket.service';
import { ClientTicketLogService } from './services/client-ticket-log.service';
import { FloorplanService } from './services/floorplan.service';
import { SurveyService } from './services/survey.service';
import { AppReleaseService } from './services/app-release.service';
import { BuildFileService } from './services/build-file.service';
import { AdminActionLogService } from './services/admin-action-log.service';
import { IntroductionInquiryService } from './services/introduction-inquiry.service';
import { IntroductionInquiryLogService } from './services/introduction-inquiry-log.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UserService,
    AdminService,
    StorageService,
    SettingService,
    InquiryService,
    FaqService,
    HealthService,
    UserLogService,
    AdminDocumentService,
    VendorDocumentService,
    VendorWorkspaceService,
    VendorWorkspaceUserService,
    VendorJoinLogService,
    VendorWorkspaceInviteLogsService,
    VendorWorkspaceApproveLogService,
    VendorActionLogService,
    ClientWorkspaceService,
    ClientWorkspaceUserService,
    ClientWorkspaceJoinLogService,
    ClientWorkspaceInviteLogService,
    ClientActionLogService,
    PartnerJoinRequestService,
    PlaylistService,
    DeviceService,
    DeviceGroupService,
    VendorInquiryService,
    AsService,
    AdminNoticeService,
    VendorNoticeService,
    NotificationService,
    CreditHistoryLogService,
    CreditRequestLogService,
    ContentsRequestService,
    ContentsRequestCommentService,
    ContentsRequestResultService,
    ContentsRequestPaymentService,
    ContentsRequestEstimateService,
    VendorTicketService,
    VendorTicketLogService,
    ClientTicketService,
    ClientTicketLogService,
    FloorplanService,
    SurveyService,
    AppReleaseService,
    BuildFileService,
    AdminActionLogService,
    IntroductionInquiryService,
    IntroductionInquiryLogService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
